import { createAsyncThunk } from "@reduxjs/toolkit";
import { VaultState } from "../state";
import { encodeBase64 } from "../../utils/base64";
import cryptographerService from "../../services/cryptographer-service";
import { saveVault } from "../../utils/vault-storage";

export const saveVaultThunk = createAsyncThunk<VaultState, { vault: VaultState }>(
  'vault/saveVault',
  async (state) => {

    const crypto = cryptographerService.getCryptographer(state.vault.info.id);
    if (!crypto) {
      throw new Error('No cryptographer available for this vault. Please unlock the vault first.');
    }

    const docCrypt = await crypto.encryptData(JSON.stringify(state.vault.data));

    saveVault({
      info: state.vault.info,
      syncState: state.vault.syncState,
      encryptedBlob: encodeBase64(docCrypt)
    });

    return {
      info: {
        id: state.vault.info.id,
        name: state.vault.info.name
      },
      syncState: state.vault.syncState,
      data: state.vault.data
    };
  }
);